/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2020 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
export const asError=r=>{if(r instanceof Error)return r;if("string"==typeof r)return new Error(r);const t=r;if(t.toString&&"function"==typeof t.toString&&"[object Object]"!==t.toString())return new Error(t.toString());try{return new Error(JSON.stringify(r))}catch{}return new Error("Unknown error",{cause:r})};